<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted, watch } from 'vue';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const searchQuery = ref('');
const loading = ref(true);
const agencies = ref([]);
const showRetryButton = ref(false);

const getProfiles = () => {
    cleanData();

    backendApi()
        .profiles()
        .index({
            pattern: searchQuery.value
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        agencies.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    agencies.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

watch(selected, (newValue) => {
    emit('update', newValue);
});

onMounted(() => getProfiles());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        item-title="name"
        item-value="id"
        :items="agencies"
        :label="hideLabel ? '' : $t('Agency')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getProfiles"
        @retry="getProfiles"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
                :subtitle="`${item.raw.description ?? ''}`"
            >
            </v-list-item>
        </template>

        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
